<template>
  <keep-alive>
      <SimCardDevicesList />
  </keep-alive>
</template>
<script>
import SimCardDevicesList from './SimCardDevicesList/SimCardDevicesList.vue'
export default {
  components: {
    SimCardDevicesList
  }
}
</script>
